import { AwsRum } from 'aws-rum-web';
import { Auth } from 'aws-amplify';
import { isString } from 'tcheck';
import { nextTick } from 'vue';

let rum;

export async function getRum(router) {
  if (rum) {
    return rum;
  }

  if (
    !isString(import.meta.env.VITE_APP_RUM_APP_ID) ||
    !isString(import.meta.env.VITE_APP_IDENTITY_POOL_ID)
  ) {
    return;
  }

  const credentials = await Auth.currentCredentials();
  if (!credentials.authenticated) {
    return;
  }

  const config = {
    endpoint: `https://dataplane.rum.${import.meta.env.VITE_APP_AWS_REGION}.amazonaws.com`,
    sessionSampleRate: 1,
    telemetries: ['errors', 'performance', 'http'],
    allowCookies: true,
    enableXRay: true,
    signing: true,
    pageIdFormat: 'PATH_AND_HASH',
    // disableAutoPageView: true,
    dispatchInterval: 1000,
  };

  const APPLICATION_ID = import.meta.env.VITE_APP_RUM_APP_ID;
  const APPLICATION_VERSION = '1.0.0';
  const APPLICATION_REGION = import.meta.env.VITE_APP_AWS_REGION || 'us-east-1';

  try {
    rum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );

    rum.setAwsCredentials(credentials);

    /**
     * Use this if automatic page navigation tracking stops working
     */
    // if (router) {
    //   router.afterEach((to, from) => {
    //     nextTick(() => {
    //       rum.recordPageView({
    //         pageId: to.path,
    //         pageTags: [to.name || 'unknown'],
    //       });
    //     });
    //   });
    // }

    return rum;
  } catch (error) {
    console.error(`Tried to initialize AWS RUM but failed: ${error}`);
  }
}
